import { lazy, Suspense } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { teal, purple } from '@mui/material/colors'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { LanguageProvider } from './context/LanguageContext'
import 'react-toastify/dist/ReactToastify.css'
import 'moment/locale/es'

// Lazy loading de páginas para mejorar performance
const Landing = lazy(() => import('./pages/public/Landing'))

const mdTheme = createTheme({
  palette: {
    primary: {
      main: teal[500],
    },
    secondary: {
      main: purple[500],
    },
  },
})

// Componente de loading centralizado
const LoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: teal[50],
    }}
  >
    <CircularProgress size={60} />
  </Box>
)

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={mdTheme}>
        <CssBaseline />
        <Router>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/*" element={<Landing />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </Router>
        <ToastContainer />
      </ThemeProvider>
    </LanguageProvider>
  )
}

export default App
